import { apiClient } from '@/lib/axios';
import { config } from '@/config';
import { LoginResponseSchema } from '@/features/auth/types';
export async function loginConnect(firebaseToken) {
    // const response = await apiClient.post<unknown>('/api/v1/auth/login-connect', { firebaseToken })
    // {{host}}/api/v1/auth/login-social
    const response = await apiClient.post('/api/v1/auth/login-social', { firebaseToken });
    if (config.isDevelopment) {
        // Log the full response during development to validate schema assumptions
        // and to surface the returned role for the admin discovery phase.
        console.log('[loginConnect] full response:', response.data);
    }
    return LoginResponseSchema.parse(response.data);
}
